export default "/images/email.svg?0a57eddf9223c9ab864ea97261915afc";